import SignInPage from "./SignInPage";
import authRoles from "../../auth/authRoles";
import CheckSso from "src/app/auth/checkSso";

const SignInConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: "sign-in",
      element: <SignInPage />,
    },
    {
      path: "check-email",
      element: <CheckSso />,
    },
  ],
};

export default SignInConfig;
